import * as React from 'react';
export const EngineerManual = () => {
    return <iframe style={{width: '100%', height: '100vh'}} src="/assets/engineermanual.pdf" />;
};


// WEBPACK FOOTER //
// ./src/Components/Main/Help/EngineerManual.tsx